import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  IConditionalValidations,
  IFormFieldsValidationModel,
} from '../../../../models/form-fields-formly-validation.model';
import { IUtilValidationConfig } from '../../../../models/form-fields-formly-conditional-validation.model';

export const parseConditionalValidatorsModelFromFieldIntoModel = (
  model: IFormFieldsValidationModel,
  field: FormlyFieldConfig
): IFormFieldsValidationModel => {
  if (
    field?.props?.['conditionalValidationsModel'] &&
    typeof field?.props?.['conditionalValidationsModel'] === 'object'
  ) {
    model.conditionalValidations = <IConditionalValidations>(
      field.props['conditionalValidationsModel']
    );
  }

  return model;
};

export const parseUtilValidatorsModelFromFieldIntoModel = (
  model: IFormFieldsValidationModel,
  field: FormlyFieldConfig
): IFormFieldsValidationModel => {
  if (Array.isArray(field?.props?.['utilValidationsModel'])) {
    model.utilValidations = <IUtilValidationConfig[]>(
      field.props?.['utilValidationsModel']
    );
  }

  return model;
};
